var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "email-forget"
  }, [_vm.wayType === 'email' ? _c('div', {
    staticClass: "email-inner"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.has,
      expression: "!has"
    }]
  }, [_c('div', {
    staticClass: "return",
    on: {
      "click": function click($event) {
        return _vm.selectWay('email');
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fonts title"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.forget2'))))]), _vm._v(" "), _c('div', {
    staticClass: "fonts intro"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.resettip'))))]), _vm._v(" "), _c('div', {
    staticClass: "fonts email"
  }, [_vm._v(_vm._s(_vm.loginName))]), _vm._v(" "), _c('div', {
    staticClass: "fonts send",
    class: {
      cover: _vm.cover
    },
    on: {
      "click": function click($event) {
        return _vm.send();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.confirmSend'))))]), _vm._v(" "), _c('p', {
    staticClass: "fonts inphone",
    on: {
      "click": function click($event) {
        return _vm.selectWay('phone');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.phoneTyoe'))))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.has,
      expression: "has"
    }]
  }, [_c('div', {
    staticClass: "fonts title"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.hasSend'))))]), _vm._v(" "), _c('div', {
    staticClass: "fonts intro"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.hasSendTip'))))]), _vm._v(" "), _c('div', {
    staticClass: "fonts send",
    on: {
      "click": _vm.sure
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.ok'))))])])]) : _vm._e(), _vm._v(" "), _vm.wayType === 'm-email' ? _c('div', {
    staticClass: "memail-inner"
  }, [_c('div', [_c('div', {
    staticClass: "fonts title mb"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.forget2'))))]), _vm._v(" "), _c('div', {
    staticClass: "fonts intro mb"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.resettip'))))]), _vm._v(" "), _c('div', {
    staticClass: "fonts email mb"
  }, [_vm._v(_vm._s(_vm.loginName))]), _vm._v(" "), _c('div', {
    staticClass: "fonts send mb",
    class: {
      cover: _vm.cover
    },
    on: {
      "click": function click($event) {
        return _vm.send();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.confirmSend'))))]), _vm._v(" "), _c('p', {
    staticClass: "fonts inphone mb",
    on: {
      "click": function click($event) {
        return _vm.selectWay('m-phone');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.phoneTyoe'))))])])]) : _vm._e(), _vm._v(" "), _c('toast-pop', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.toastState,
      expression: "toastState"
    }],
    attrs: {
      "txt": _vm.txt
    }
  }), _vm._v(" "), _c('pop-pop', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.has && _vm.wayType === 'm-email',
      expression: "has && wayType==='m-email'"
    }],
    attrs: {
      "txt": _vm.poptxt
    },
    on: {
      "clickPop": _vm.clickPopHandle
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };